import Button from '../../../design-system/primitives/Button.jsx'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../design-system/primitives/Modal.jsx'

export default function DocumentsDeleteModal({ open, fileName, deleting, onClose, onConfirm }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      titleId="doc-delete-title"
      describedById="doc-delete-desc"
      contentClassName="admin-modal-content admin-modal-content--compact"
    >
      <ModalHeader>
        <h3 id="doc-delete-title" className="admin-modal-title">Remove document?</h3>
      </ModalHeader>
      <ModalBody>
        <p id="doc-delete-desc" className="admin-panel-description">
          Remove <strong>{fileName}</strong> from the knowledge base? This cannot be undone.
        </p>
      </ModalBody>
      <ModalFooter className="admin-modal-footer">
        <Button type="button" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="danger"
          disabled={deleting}
          onClick={onConfirm}
        >
          {deleting ? 'Removing…' : 'Remove'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
